import { RouteStatus } from '../enums';

/**
 * Estados terminales: la ruta queda en pantalla solo como información y no
 * admite ninguna acción (editar, asignar conductor, agregar pedidos, cancelar).
 */
export const ROUTE_STATUSES_READ_ONLY: readonly RouteStatus[] = [
  RouteStatus.COMPLETED,
  RouteStatus.CANCELLED,
  RouteStatus.CLOSED,
];

/**
 * Estados en los que la ruta todavía no salió a recorrer y se puede cancelar a
 * mano. Espeja `ROUTE_STATUSES_NOT_STARTED` del backend.
 */
export const ROUTE_STATUSES_CANCELLABLE: readonly RouteStatus[] = [
  RouteStatus.CREATED,
  RouteStatus.ASSIGNED,
  RouteStatus.PENDING_DRIVER_CONFIRMATION,
  RouteStatus.PENDING_HERMES_ASSIGN,
];

export const isRouteReadOnly = (status: RouteStatus | string): boolean =>
  ROUTE_STATUSES_READ_ONLY.includes(status as RouteStatus);

export const isRouteCancelled = (status: RouteStatus | string): boolean =>
  status === RouteStatus.CANCELLED;

export const isRouteCancellable = (route: {
  status: RouteStatus | string;
  startedAt?: string | null;
  logisticOperatorId?: string | null;
}): boolean =>
  Boolean(route.logisticOperatorId) &&
  !route.startedAt &&
  ROUTE_STATUSES_CANCELLABLE.includes(route.status as RouteStatus);

/**
 * Una ruta guardada sin conductor queda con el conductor comodín "Sin Asignar",
 * así que tener `driver` no significa que alguien la esté llevando.
 */
export const isUnassignedPlaceholderDriver = (driver?: {
  firstName?: string | null;
  lastName?: string | null;
} | null): boolean => {
  if (!driver) return false;
  return (
    `${driver.firstName ?? ''} ${driver.lastName ?? ''}`.trim().toLowerCase() ===
    'sin asignar'
  );
};

/**
 * Mientras la ruta no salió a recorrer se le puede cambiar el conductor
 */
export const isRouteDriverEditable = (route: {
  status: RouteStatus | string;
  startedAt?: string | null;
}): boolean =>
  !route.startedAt &&
  ROUTE_STATUSES_CANCELLABLE.includes(route.status as RouteStatus);
